import React from 'react'
import grn from '../Assets/green_bg.png'
import red from '../Assets/red_bg.png'
import n5 from '../Assets/n5_bg.png'
import n0 from '../Assets/n0_bg.png'

const Ball = ({ addBall, i }) => {
  return (
        // <div onClick={() => addBall(i)} style={{ 
        //     borderLeft:`${i % 2 !== 0 && i !== 5 && i !== 0 ? 'green 3px solid' : ''} 
        //      ${i % 2 === 0 && i !== 5 && i !== 0 ? 'red 3px solid' : ''}  ${i === 0 || i === 5 ? 'purple 3px solid' : ''}`,
        //     borderBottom:`${i % 2 !== 0 && i !== 5 && i !== 0 ? 'green 3px solid' : ''} 
        //      ${i % 2 === 0 && i !== 5 && i !== 0 ? 'red 3px solid' : ''}  ${i === 0 || i === 5 ? 'purple 3px solid' : ''}`,
        //     borderRight:`${i % 2 !== 0 ? 'green 3px solid' : ''} 
        //      ${i % 2 === 0 ? 'red 3px solid' : ''}`,
        //     borderTop:`${i % 2 !== 0 ? 'green 3px solid' : ''} 
        //      ${i % 2 === 0 ? 'red 3px solid' : ''}`,
        //  '--i':`${i % 2 !== 0 && i !== 5 ? 'green' : ''} 
        //   ${i % 2 === 0 && i !== 0 ? 'red' : ''} 
        //    ${i === 0 || i === 5 ? 'purple' :''  }` 
        // }} 
        //    className="circlen cursor-pointer">
        //   <span style={{ '--i':`${i % 2 !== 0 && i !== 5 ? 'green' : ''} 
        //   ${i % 2 === 0 && i !== 0 ? 'red' : ''} 
        //    ${i === 0 || i === 5 ? 'purple' :''  }`, 
        //    '--e':`${i % 2 !== 0 ? 'green' : ''} 
        //    ${i % 2 === 0 ? 'red' : ''} 
        //     ` }} className='font-bold text-2xl'>
        //     {i}
        //     </span>
        // </div>
        <div onClick={() => addBall(i)} className='flex flex-col justify-center items-center'>

        <div className='container cursor-pointer flex justify-center items-center'>
          { i % 2 !== 0 && i !== 5 && <img className='image max-w-[34px] max-h-[34px]' src={grn} alt='' />}      
          { i % 2 === 0 && i !== 0 && <img className='max-w-[34px] max-h-[34px]' src={red} alt=''/>}
          { i === 0 && <img className='max-w-[34px] max-h-[34px]' src={n0} alt=''/>}
          { i === 5 && <img className='max-w-[34px] max-h-[34px]' src={n5} alt=''/>}
          <p className={`number text-center font-bold ${i % 2 !== 0 && 'text-green-500'} ${i % 2 === 0  && 'text-red-500'}`}>{i}</p>
        </div>
          <p className='text-black font-semibold'>9</p>
        </div>
  )
}

export default Ball